import { Card, Divider, message } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import {
  ContainerModal,
  ItemTextModal,
  ItemWrapper,
  TextModal,
  Title,
} from "../styles";
import { formatPhoneNumber } from "../../../uteis/formatPhoneNumber";
import { useBuscarInt } from "../hooks/useBuscarInt";
import { useBuscarInfoInteresseUser } from "../hooks/useBuscarInfoInteresseUser";

export default function ModalInt({
  id,
  isOpen,
}: {
  id: number;
  isOpen: boolean;
}) {
  const { int, isLoading } = useBuscarInt(id, isOpen);
  const intId = int?.id;

  const { infoUser, isLoading: isLoadingInfoUser } = useBuscarInfoInteresseUser(
    intId,
    isOpen && !!intId
  );

  if (isLoading || isLoadingInfoUser) {
    return <p>{"Carregando Informa\u00e7\u00f5es..."}</p>;
  }

  if (!int || !infoUser?.usuarioTable) {
    return (
      <p>
        {"Nenhuma informa\u00e7\u00e3o de contato encontrada para este interesse."}
      </p>
    );
  }

  return (
    <Card
      title={<Title>{"Informa\u00e7\u00f5es do Interessado"}</Title>}
      style={{
        width: "100%",
        marginTop: "20px",
        borderRadius: "10px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <ContainerModal>
        {[
          {
            label: "Nome",
            value:
              infoUser?.usuarioTable.nome +
              " " +
              infoUser?.usuarioTable.sobrenome,
          },
          {
            label: "Email",
            value: infoUser?.usuarioTable.email,
          },
          {
            label: "Celular",
            value: (
              <>
                {formatPhoneNumber(infoUser?.usuarioTable.celular ?? "")}
                <CopyOutlined
                  onClick={() => {
                    if (infoUser?.usuarioTable.celular) {
                      navigator.clipboard.writeText(
                        infoUser.usuarioTable.celular
                      );
                      message.success(
                        "N\u00famero copiado para a \u00e1rea de transfer\u00eancia!"
                      );
                    }
                  }}
                  style={{
                    marginLeft: 8,
                    cursor: "pointer",
                    color: "#1677ff",
                  }}
                />
              </>
            ),
          },
        ].map((item, index) => (
          <ItemWrapper key={index}>
            <ItemTextModal>{item.label}</ItemTextModal>
            <TextModal>{item.value}</TextModal>
            {index < 8 && <Divider />}
          </ItemWrapper>
        ))}
      </ContainerModal>
    </Card>
  );
}
